import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'react-recompose';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { Input, Button, Select } from 'antd';
import { Refresh, ArrowDropDown, Search } from '@material-ui/icons';

const { Option } = Select;

function CouponFilter({ intl, searchText, onStateFilter, onSort, onSearch, onKeyDownSearch, onApplyFilter }) {
  const couponStates = [
    { value: 'A', label: intl.formatMessage({ id: 'Active' }) },
    { value: 'I', label: intl.formatMessage({ id: 'Inactive' }) },
  ];
  const couponSorts = [
    { value: 'state desc', label: intl.formatMessage({ id: 'By state' }) },
    {
      value: 'startAt desc',
      label: intl.formatMessage({ id: 'By start date' }),
    },
    { value: 'endAt desc', label: intl.formatMessage({ id: 'By end date' }) },
    {
      value: 'createdAt desc',
      label: intl.formatMessage({ id: 'By creation date' }),
    },
  ];

  const handleStateFilter = values => {
    onStateFilter(values);
  };

  const handleSort = value => {
    onSort(value);
  };

  const handleSearch = e => {
    onSearch(e);
  };

  return (
    <div className="coupon_filter_layout">
      <Select
        className="active_states"
        suffixIcon={<ArrowDropDown />}
        mode="multiple"
        placeholder="estados activos"
        onChange={handleStateFilter}
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
      >
        {couponStates.map(item => (
          <Option value={item.value} key={item.label}>
            {item.label}
          </Option>
        ))}
      </Select>
      <Select
        className="sort_by"
        suffixIcon={<ArrowDropDown />}
        placeholder="Ordernar por"
        onChange={handleSort}
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
      >
        {couponSorts.map(item => (
          <Option value={item.value} key={item.label}>
            {item.label}
          </Option>
        ))}
      </Select>
      <Button className="apply_filters_btn" onClick={onApplyFilter}>
        <FormattedMessage id="Apply filters" />
        <Refresh />
      </Button>
      <Input
        suffix={<Search />}
        placeholder="Buscar Cupone"
        value={searchText}
        onChange={e => handleSearch(e)}
        onKeyDown={e => onKeyDownSearch(e)}
      />
    </div>
  );
}

export default compose(injectIntl)(CouponFilter);
